import React, { useCallback, useEffect, useState } from 'react';
import { useDebouncedCallback } from '@mantine/hooks';
import { useEventListener } from 'ahooks';

export const useCols = () => {
  // 根据不同的显示尺寸来决定model的个数
  const [cols, setCols] = useState(4);
  useEffect(() => {
    calcCols();
  }, []);

  // ratio 和 cols 共同决定了自适应卡片宽高和列数
  const calcCols = () => {
    switch (true) {
      case innerWidth < 900:
        setCols(2);
        break;
      case innerWidth >= 900 && innerWidth <= 1200:
        setCols(3);
        break;
      case innerWidth >= 1200 && innerWidth <= 1500:
        setCols(4);
        break;
      case innerWidth >= 1500 && innerWidth <= 1700:
        setCols(5);
        break;
      case innerWidth >= 1700 && innerWidth <= 1920:
        setCols(6);
        break;
      case innerWidth > 1920:
        setCols(7);
        break;
      default:
    }
  };

  const resizeWindow = useDebouncedCallback(() => {
    calcCols();
  }, 200);

  useEventListener('resize', resizeWindow);
  return { cols };
};
